import React, { useRef } from "react";
import { dispatchChrCustomClickEventFor } from "../../../hooks/generic/Utils/useToggler.jsx";
import ChrPopover from "../Utils/ChrPopover";
import { actionsConfig } from "./constants.js";

const FilterBody = props => {
  const {
    show,
    data,
    additionalClass,
    showActions
  } = props;

  const displayClass = show ? "" : "hide";

  const {
    fixedHeight,
    fixedHeightClass = "custom-height-20",
    heightClass = "custom-max-height-22",
    fixedWidth,
    fixedWidthClass = "custom-width-20",
    widthClass = "custom-min-width-12 custom-max-width-22",
  } = props;

  const filterBodyWrapperComponent = useRef(null);

  const computedHeightClass = fixedHeight ? fixedHeightClass : heightClass;
  const computedWidthClass = fixedWidth ? fixedWidthClass : widthClass;

  let actions = [];
  if (showActions) {
    actions = Object.values(actionsConfig(props));
  }

  const filterBodyOnClickHandler = event => {
    event.stopPropagation();
    dispatchChrCustomClickEventFor(event);
  };

  return (
    <div ref={ filterBodyWrapperComponent } >
      <div onClick={ filterBodyOnClickHandler }>
        <ChrPopover
          parentWrapperRef={ props.parentWrapperRef }
          dimensionClasses={ `${computedHeightClass} ${computedWidthClass}` }
          additionalClasses={ `${displayClass} ${additionalClass}` }
          actions={ actions }
        >
          { data }
        </ChrPopover>
      </div>
    </div>
  );
};

export default FilterBody;